import LoginPageContainer from './containers/LoginPageContainer'

export default LoginPageContainer
